/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable unicorn/no-useless-undefined */
/* eslint-disable unicorn/no-lonely-if */
/* eslint-disable unicorn/no-document-cookie */
/* eslint-disable no-console */
/* eslint-disable promise/always-return */
/* eslint-disable array-callback-return */
/* eslint-disable prefer-const */
/* eslint-disable no-case-declarations */
/* eslint-disable complexity */
/* eslint-disable unicorn/prevent-abbreviations */
/* eslint-disable no-unused-vars */
/* eslint-disable prettier/prettier */
/* eslint-disable unicorn/no-array-for-each */
import formValidation from 'formvalidation/core/Core';
import SelectorEngine from '../../utils/dom/selector-engine';
import Select from '../../components/Select';
import Request from '../../utils/request';
import Manipulator from '../../utils/dom/manipulator';
import { scrollToTop } from '../../utils/misc';

import ValidationUtils from '../../utils/validation';
import getValidationRules from './personal-details-validation-rules';
import Modal from '../../components/Modal';
import EventHandler from '../../utils/dom/event-handler';
import SuggestionInput from '../../components/SuggestionInput';

class EditPersonalDetails {
	constructor() {
		this._container = SelectorEngine.findOne('.js-edit-personal-details');
		this._cancelCta = undefined;
		this._backCta = undefined;
		this._exitModal = undefined;
		this._diversityModal = undefined;
		this._studyingAtUniversity = false;
		this.state = {
			responseData: {},
			selectedEthnicity: '',
			ethnicity: {},
			disability: {},
			faith: {},
			genderAssignment: {},
			sexualOrientation: {},
			graduationYear: {},
			randomData: {},
			disabilityType: [],
			subDisabilities: [],
			universitySelectEventName: "universitySelect",
			universitySelectDataKey: "schoolName",
			universityName: "",
			universityId: "",
			graduationYear: ""
		};

		if (this._container) {
			this.initiateValidation();
		}
	}

	// Sub
	get subEthnicityGroupsData() {
		return this._subEthnicityGroups;
	}
	set subEthnicityGroupsData(subEthnicityGroups = []) {
		this._subEthnicityGroups = subEthnicityGroups;
		this._updateSubEthnicityGroups();
	}

	// Ethnicity
	get ethnicityGroupsData() {
		return this._ethnicityGroups;
	}
	set ethnicityGroupsData(ethnicityGroups = []) {
		this._ethnicityGroups = ethnicityGroups;
		this._updateEthnicityGroups();
	}

	// Faith
	get faithGroupsData() {
		return this._faithGroups;
	}
	set faithGroupsData(faithGroups = []) {
		this._faithGroups = faithGroups;
		this._updateFaithGroups();
	}

	// Sexual Orientation
	get sexualOrientationGroupsData() {
		return this._sexualOrientationGroups;
	}
	set sexualOrientationGroupsData(sexualOrientationGroups = []) {
		this._sexualOrientationGroups = sexualOrientationGroups;
		this._updateSexualOrientationGroups();
	}

	// Graduation Year
	get graduationYearGroupsData() {
		return this._graduationYearGroups;
	}

	set graduationYearGroupsData(graduationYearGroups = []) {
		this._graduationYearGroups = graduationYearGroups;
		this._updateGraduationYearGroups();
	}

	get universityStudent() {
		return this._studyingAtUniversity;
	}

	set universityStudent(_studyingAtUniversity) {
		this._studyingAtUniversity = _studyingAtUniversity;
		this.showUniversity(!!_studyingAtUniversity);
		if(!_studyingAtUniversity) {
			this.selectedUniversity = null;
		}
	}

	// Gender Assignment
	get genderAssignmentGroupsData() {
		return this._genderAssignmentGroups;
	}
	set genderAssignmentGroupsData(genderAssignmentGroups = []) {
		this._genderAssignmentGroups = genderAssignmentGroups;
		this._updateGenderAssignmentGroups();
	}

	// Disability
	get disabilityGroupsData() {
		return this._disabilityGroups;
	}
	set disabilityGroupsData(disabilityGroups = []) {
		this._disabilityGroups = disabilityGroups;
		this._updateDisabilityGroups();
	}

	get apiDIData() {
		return this._getDIData;
	}

	set apiDIData(apiData = []) {
		this._getDIData = apiData;
		this._updateDIData();
	}

	get selectedUniversity() {
		return this._selectedUniversity;
	}

	set selectedUniversity(_selectedUniversity) {
		this._selectedUniversity = _selectedUniversity || null;
		this.fv.validateField('university');
		this.showGraduationYear(!!_selectedUniversity);
	}
	
	initiateValidation() {
		this._exitModal = new Modal(SelectorEngine.findOne('#exit-editing'), {});
		this._diversityModal = new Modal(SelectorEngine.findOne('#diversity-modal'), {});
		this.editPersonalDetailsForm = SelectorEngine.findOne('#editPersonalDetails', this._container);
		this.errorWrapper = SelectorEngine.findOne('.js-personal-details--error', this._container);
		this.errorDefault = SelectorEngine.findOne('.js-personal-details--error-default', this._container);
		this.errorFieldsContainer = SelectorEngine.findOne('.js-personal-details__fields-error', this._container);
		const closeDiversityModal = this._diversityModal._element.querySelector('.js-diversity-info-cancel');
		this.checkboxForms = SelectorEngine.find('.disability_type .lta-form-check-input', this._wrapper);
		this.userAge = Manipulator.getDataAttribute(this.editPersonalDetailsForm, 'age');

		EventHandler.on(closeDiversityModal, 'click', () => {
			this._diversityModal.hide();
		});

		this.checkboxForms && this.checkboxForms.forEach((form) => {
			form.addEventListener('change', (event) => {
				this.checkForm(event);
			});
		});

		this.errorDismissCta = SelectorEngine.findOne('.js-dismiss-account-error', this._container);
		this.errorDismissCta.addEventListener('click', () => {
			this.errorWrapper.classList.add('u-hidden');
		});

		this.errorDefaultDismissCta = SelectorEngine.findOne('.js-dismiss-account-error-default', this._container);
		this.errorDefaultDismissCta.addEventListener('click', () => {
			this.errorDefault.classList.add('u-hidden');
		});

		this.errorFieldsWrapper = SelectorEngine.findOne(
			'.js-personal-details__fields-error-content',
			this.errorFieldsContainer
		);
		this.fieldsErrorsList = SelectorEngine.findOne('ul', this.errorFieldsWrapper);
		this.fieldsErrorsList.textContent = '';

		const ethnicityGroup = SelectorEngine.findOne('.ethnicity_groups .js-lta-select', this.editPersonalDetailsForm);
		this.ethnicityGroupElement = ethnicityGroup && (Select.getInstance(ethnicityGroup) || new Select(ethnicityGroup));
		EventHandler.on(this.ethnicityGroupElement && this.ethnicityGroupElement._selectNativeElement, 'change', this.subEthnicityGroupPopulate.bind(this));

		const subEthnicityGroup = SelectorEngine.findOne('.ethnicity_subgroups .js-lta-select', this.editPersonalDetailsForm);
		this.subEthnicityGroupElement = subEthnicityGroup && (Select.getInstance(subEthnicityGroup) || new Select(subEthnicityGroup));

		const disability = SelectorEngine.findOne('.disability .js-lta-select', this.editPersonalDetailsForm);
		this.disabilityGroupElement = disability && (Select.getInstance(disability) || new Select(disability));
		EventHandler.on(this.disabilityGroupElement && this.disabilityGroupElement._selectNativeElement, 'change', this.subDisabilitiesPopulate.bind(this));

		const faith = SelectorEngine.findOne('.faith .js-lta-select', this.editPersonalDetailsForm);
		this.faithGroupElement = faith && (Select.getInstance(faith) || new Select(faith));

		const sexualOrientation = SelectorEngine.findOne('.sexualOrientation .js-lta-select', this.editPersonalDetailsForm);
		this.sexualOrientationGroupElement = sexualOrientation && (Select.getInstance(sexualOrientation) || new Select(sexualOrientation));

		const graduationYear = SelectorEngine.findOne('.graduationYear .js-lta-select', this.editPersonalDetailsForm);
		this.graduationYearGroupElement = graduationYear && (Select.getInstance(graduationYear) || new Select(graduationYear));

		const genderAssignment = SelectorEngine.findOne('.genderAssignment .js-lta-select', this.editPersonalDetailsForm);
		this.genderAssignmentGroupElement = genderAssignment && (Select.getInstance(genderAssignment) || new Select(genderAssignment));

		this._cancelCta = SelectorEngine.findOne('.js-account-exit', this._wrapper);
		this._cancelCta.addEventListener('click', (event) => this.backToUrl(event));

		this._backCta = SelectorEngine.findOne('.js-account-edit-back', this._wrapper);
		this._backCta.addEventListener('click', (event) => this.exitEditing(event));

		const popupCancel = SelectorEngine.findOne('.js-account-details-continue');
		popupCancel.addEventListener('click', () => this._exitModal.hide());

		const popupContinue = SelectorEngine.findOne('.js-account-details-exit');
		popupContinue.addEventListener('click', (event) => this.backToUrl(event));

		this.fetchData();

		if (this.editPersonalDetailsForm !== null) {	
			const personalDetailsValidationRules = getValidationRules(this.universityValidation.bind(this));
			this.fv = formValidation(this.editPersonalDetailsForm, personalDetailsValidationRules)
				.on('core.field.invalid', (name) => this.fieldInvalid(name))
				.on('core.field.valid', (name) => this.fieldValid(name))
				.on('core.form.invalid', () => this.formInvalid())
				.on('core.form.validating', () => this.formValidating())
				.on('plugins.message.displayed', (e) => this.messageDisplayed(e))
				.on('core.form.valid', () => this.formValid());

		}

		this.universitySuggestionInputContainer = SelectorEngine.findOne('.lta-venue-suggest', this.editPersonalDetailsForm);
		this.universitySuggestionInputElement = SelectorEngine.findOne('input', this.universitySuggestionInputContainer);
		this.universitySuggestionInput = SuggestionInput.getOrCreateInstance(this.universitySuggestionInputContainer);
		if(this.universitySuggestionInputElement.value) {
			this.selectedUniversity = { schoolName: this.universitySuggestionInputElement.value };
		}

		this.universitySuggestionInput.state.eventName = this.state.universitySelectEventName;
		this.universitySuggestionInput.state.dataKey = this.state.universitySelectDataKey;
		this.universitySuggestionInput.state.keepTypingLength = 3;
		this.universitySuggestionInput.state.inputLength = 3;
		this.universitySuggestionInput.state.dataMapping = (data) => {
			return {
				firstLineText: data.schoolName,
				secondLineText: `${data.address.street}, ${data.address.postcode} ${data.address.city}, ${data.address.country}`,
				dataKey: this.universitySuggestionInput.state.dataKey,
				dataValue: data.id
			};
		}

		this.universitySuggestionInput.state.filterDataMapping = (data, event) => {
			return data.id === event[this.universitySuggestionInput.state.dataKey];
		}
		
		EventHandler.on(this.universitySuggestionInputContainer, this.state.universitySelectEventName, (event) => {
			this.selectedUniversity = event.detail;
			this.universitySuggestionInputElement.value = this.selectedUniversity.schoolName;
		});

		this.universityStudentElement = SelectorEngine.findOne('input[name="universityStudent"][checked]', this.editPersonalDetailsForm);
		if(this.universityStudentElement) {
			this.universityStudent = this.universityStudentElement.value === 'Yes';
		}

		EventHandler.on(this.editPersonalDetailsForm, 'change', (event) => {
			if(event.target.name === 'universityStudent') {
				this.universityStudent = event.target.value === 'Yes';
			}
		});
	}

	showUniversity(flag) {
		const universityElement = SelectorEngine.findOne('.university', this.editPersonalDetailsForm);
		if(flag) {
			universityElement.classList.remove('u-hidden');
			if(this.fv) {
				this.fv.enableValidator('university');
			}
		} else {
			universityElement.classList.add('u-hidden');
			this.universitySuggestionInput.clearSelectedResults();
			this.universitySuggestionInputElement.value = "";
			if(this.fv) {
				this.fv.disableValidator('university');
			}
		}
	}

	showGraduationYear(flag) {
		if(flag) {
			SelectorEngine.findOne('.graduationYear', this.editPersonalDetailsForm).classList.remove('u-hidden');
			if(this.fv) {
				this.fv.enableValidator('graduationYear');
			}
		} else {
			SelectorEngine.findOne('.graduationYear', this.editPersonalDetailsForm).classList.add('u-hidden');
			this.graduationYearGroupElement.reset();
			if(this.fv) {
				this.fv.disableValidator('graduationYear');
			}
		}
	}

	checkForm(e) {
		const inputChanged = e.target;
		if(inputChanged.checked) {
			if(!this.state.disabilityType.includes(inputChanged.value)) {
				this.state.disabilityType.push(inputChanged.value);
			}
		} else {
			if(this.state.disabilityType.includes(inputChanged.value)) {
				this.state.disabilityType = this.state.disabilityType.filter(num => num !== inputChanged.value);
			}
		}
	}

	async fetchData() {
		await Request.get('/api/account/GetDIDataCapture').then((data) => {
			this.state.responseData = data;
			this.apiDIData = data;
			data.map(value => {
				switch(value?.id) {
					case "ethnicity":
						this.state.ethnicity = Object.assign(this.state.ethnicity, value?.answer);
						let ethnicityItems = {};
						let defaultEhtnicityValue = "";
						Object.keys(this.state.ethnicity).map(i => {
							ethnicityItems[this.state.ethnicity[i].id] = this.state.ethnicity[i].value;
							if(this.state.ethnicity[i].defaultValue == 'Yes') {
								defaultEhtnicityValue = this.state.ethnicity[i].value;
							}
						});
						if (this.ethnicityGroupElement) {
							this.ethnicityGroupsData = ethnicityItems;
							if(defaultEhtnicityValue) {
								this.ethnicityGroupElement._selectedElement.children[0].innerHTML = defaultEhtnicityValue;
								this.ethnicityGroupElement._selectNativeElement.value = defaultEhtnicityValue;
							}
							this.subEthnicityGroupPopulate();
						}
						break;
					case "disability":
						this.state.disability = Object.assign(this.state.disability, value?.answer);
						let disabilityItems = {};
						let defaultValue = "";
						Object.keys(this.state.disability).map(i => {
							disabilityItems[this.state.disability[i].id] = this.state.disability[i].value;
							if(this.state.disability[i].defaultValue == 'Yes') {
								defaultValue = this.state.disability[i].value;
								this.state.subDisabilities = this.state.disability[i].level2Response;
							}
						});
						if (this.disabilityGroupElement) {
							this.disabilityGroupsData = disabilityItems;
							this.subDisabilitiesPopulate();
							if(defaultValue) {
								this.disabilityGroupElement._selectedElement.children[0].innerHTML = defaultValue;
								this.disabilityGroupElement._selectNativeElement.value = defaultValue;
							}
						} 
						break;
					case "faith":
						this.state.faith = Object.assign(this.state.faith, value?.answer);
						let faithItems = {};
						let defaultFaithValue = "";
						Object.keys(this.state.faith).map(i => {
							faithItems[this.state.faith[i].id] = this.state.faith[i].value;
							if(this.state.faith[i].defaultValue == 'Yes') {
								defaultFaithValue = this.state.faith[i].value;
							}
						});
						if (this.faithGroupElement) {
							this.faithGroupsData = faithItems;
							if(defaultFaithValue) {
								this.faithGroupElement._selectedElement.children[0].innerHTML = defaultFaithValue;
								this.faithGroupElement._selectNativeElement.value = defaultFaithValue;
							}
						}
						break;
					case "genderAssignment":
						this.state.genderAssignment = Object.assign(this.state.genderAssignment, value?.answer);
						let genderAssignmentItems = {};
						let defaultGenderAssignmentValue = "";
						Object.keys(this.state.genderAssignment).map(i => {
							genderAssignmentItems[this.state.genderAssignment[i].id] = this.state.genderAssignment[i].value;
							if(this.state.genderAssignment[i].defaultValue == 'Yes') {
								defaultGenderAssignmentValue = this.state.genderAssignment[i].value;
							}
						});
						if (this.genderAssignmentGroupElement) {
							this.genderAssignmentGroupsData = genderAssignmentItems;
							if(defaultGenderAssignmentValue) {
								this.genderAssignmentGroupElement._selectedElement.children[0].innerHTML = defaultGenderAssignmentValue;
								this.genderAssignmentGroupElement._selectNativeElement.value = defaultGenderAssignmentValue;
							}
						}
						break;
					case "sexualOrientation":
						this.state.sexualOrientation = Object.assign(this.state.sexualOrientation, value?.answer);
						let sexualOrientationItems = {};
						let defaultSexualOrientationValue = "";
						Object.keys(this.state.sexualOrientation).map(i => {
							sexualOrientationItems[this.state.sexualOrientation[i].id] = this.state.sexualOrientation[i].value;
							if(this.state.sexualOrientation[i].defaultValue == 'Yes') {
								defaultSexualOrientationValue = this.state.sexualOrientation[i].value;
							}
						});
						if (this.sexualOrientationGroupElement) {
							this.sexualOrientationGroupsData = sexualOrientationItems;
							if(defaultSexualOrientationValue) {
								this.sexualOrientationGroupElement._selectedElement.children[0].innerHTML = defaultSexualOrientationValue;
								this.sexualOrientationGroupElement._selectNativeElement.value = defaultSexualOrientationValue;
							}
						}
						break;
					case "graduationYear":
						this.state.graduationYear = Object.assign(this.state.graduationYear, value?.answer);
						let graduationYearItems = {};
						let defaultGraduationYearValue = "";
						Object.keys(this.state.graduationYear).map(i => {
							graduationYearItems[this.state.graduationYear[i].id] = this.state.graduationYear[i].value;
							if(this.state.graduationYear[i].defaultValue == 'Yes') {
								defaultGraduationYearValue = this.state.graduationYear[i].value;
							}
						});
						if (this.graduationYearGroupElement) {
							this.graduationYearGroupsData = graduationYearItems;
							if(defaultGraduationYearValue) {
								this.graduationYearGroupElement._selectedElement.children[0].innerHTML = defaultGraduationYearValue;
								this.graduationYearGroupElement._selectNativeElement.value = defaultGraduationYearValue;
							}
						}
						break;
					default:
						break;
				}
			});
		}).catch((error) => {
			console.log(error);
		});
	}

	_updateDIData() {
		if (this.userAge && this.userAge > 12) {
			if(!('; '+document.cookie).split(`; di-popup-loaded=`).pop().split(';')[0]) {
				if(!this.defaultValueExists()) {
					this._diversityModal.show();
					let now = new Date();
					let time = now.getTime();
					time += 3600 * 1000;
					now.setTime(time);
					document.cookie = 'di-popup-loaded=' + true + '; expires=' + now.toUTCString() + '; path=/';
				}
			}
		}
	}

	defaultValueExists() {
		let valueExist = false;
		this.apiDIData && this.apiDIData.length > 0 && this.apiDIData.map(i => {
			// eslint-disable-next-line consistent-return
			i.answer.some(j => {
				if(j.defaultValue === 'Yes') {
					valueExist = true;
					return valueExist;
				}
			})
		})
		return valueExist;
	}

	subDisabilitiesPopulate(event) {
		SelectorEngine.findOne('.disability_type', this.editPersonalDetailsForm)?.classList.add('u-hidden');
		const disabilityValue = this.disabilityGroupElement && this.disabilityGroupElement._selectNativeElement.value;
		this.state.selectedDisability = disabilityValue;
		if(!event) {
			if(this.state.subDisabilities !== null && this.state.subDisabilities.length > 0) {
				SelectorEngine.findOne('.disability_type', this.editPersonalDetailsForm).classList.remove('u-hidden');
				this.state.subDisabilities.map((value, index) => {
					if(value.defaultValue == 'Yes') {
						this.checkboxForms[index].checked = true;
						if(!this.state.disabilityType.includes(value.value)) {
							this.state.disabilityType.push(value.value);
						}
					} else {
						this.checkboxForms[index].checked = false;
						if(this.state.disabilityType.includes(value.value)) {
							this.state.disabilityType = this.state.disabilityType.filter(num => num !== value.value);
						}
					}
				})
			}
		} else {
			Object.keys(this.state.disability).map(i => {
				if(this.state.disability[i].value == disabilityValue && this.state.disability[i].level2Response !== null && this.state.disability[i].level2Response.length > 0) {
					SelectorEngine.findOne('.disability_type', this.editPersonalDetailsForm).classList.remove('u-hidden');
					this.state.disability[i].level2Response.map((value, index) => {
						this.checkboxForms[index].checked = false;
						this.state.disabilityType = [];
					})
				}
			});
		}
	}

	subEthnicityGroupPopulate() {
		SelectorEngine.findOne('.ethnicity_subgroups', this.editPersonalDetailsForm)?.classList.add('u-hidden');
		const ethnicityValue = this.ethnicityGroupElement && this.ethnicityGroupElement._selectNativeElement.value;
		this.state.selectedEthnicity = ethnicityValue;

		Object.keys(this.state.ethnicity).map(i => {
			let subEthnicityDefaultValue = "", subItems = {};
			if(ethnicityValue && ethnicityValue == this.state.ethnicity[i]?.value  && this.state.ethnicity[i].level2Response.length > 0) {
				SelectorEngine.findOne('.ethnicity_subgroups', this.editPersonalDetailsForm)?.classList.remove('u-hidden');
				let subData = this.state.ethnicity[i].level2Response;
				subData.map(value => {
					subItems[value.id] = value.value;
					if(value.defaultValue == 'Yes') {
						subEthnicityDefaultValue = value.value; 
					}
				});
				this.subEthnicityGroupsData = subItems;
				if(subEthnicityDefaultValue) {
					this.subEthnicityGroupElement._selectedElement.children[0].innerHTML = subEthnicityDefaultValue;
					this.subEthnicityGroupElement._selectNativeElement.value = subEthnicityDefaultValue;
				}
			} else if (ethnicityValue && ethnicityValue == this.state.ethnicity[i]?.value  && this.state.ethnicity[i].level2Response.length === 0) {
					this.subEthnicityGroupElement._selectedElement.children[0].innerHTML = "";
					this.subEthnicityGroupElement._selectNativeElement.value = "";
				}
		})
	}

	_updateEthnicityGroups() {
		this.ethnicityGroupElement?.clearItems();
		const element = SelectorEngine.findOne('select', this.ethnicityGroupElement?._element);
		const options = [
			`<option value="" disabled="" selected="">- Please select -</option>`,
			...Object.keys(this.ethnicityGroupsData).map((index) => {
				const subGroups = this.ethnicityGroupsData[index];
				return `<option value="${subGroups}">
							${subGroups}
						</option>`;
			})
		].join('');
		if (element) {
			element.innerHTML = options;
			this.ethnicityGroupElement?.generateItems();
		}
	}

	// Populate Dropdown values
	_updateSubEthnicityGroups() {
		this.subEthnicityGroupElement?.clearItems();
		const element = SelectorEngine.findOne('select', this.subEthnicityGroupElement?._element);
		const options = [
			`<option value="" disabled="" selected="">- Please select -</option>`,
			...Object.keys(this.subEthnicityGroupsData).map((index) => {
				const subGroups = this.subEthnicityGroupsData[index];
				return `<option value="${subGroups}">
							${subGroups}
						</option>`;
			})
		].join('');
		if (element) {
			element.innerHTML = options;
			this.subEthnicityGroupElement?.generateItems();
		}
	}

	_updateDisabilityGroups() {
		this.disabilityGroupElement?.clearItems();
		const element = SelectorEngine.findOne('select', this.disabilityGroupElement?._element);
		const options = [
			`<option value="" disabled="" selected="">- Please select -</option>`,
			...Object.keys(this.disabilityGroupsData).map((index) => {
				const subGroups = this.disabilityGroupsData[index];
				return `<option value="${subGroups}">
							${subGroups}
						</option>`;
			})
		].join('');
		if(element) {
			element.innerHTML = options;
			this.disabilityGroupElement?.generateItems();
		}
	}

	_updateFaithGroups() {
		this.faithGroupElement?.clearItems();
		const element = SelectorEngine.findOne('select', this.faithGroupElement?._element);
		const options = [
			`<option value="" disabled="" selected="">- Please select -</option>`,
			...Object.keys(this.faithGroupsData).map((index) => {
				const subGroups = this.faithGroupsData[index];
				return `<option value="${subGroups}">
							${subGroups}
						</option>`;
			})
		].join('');
		if (element) {
			element.innerHTML = options;
			this.faithGroupElement?.generateItems();
		}
	}

	_updateGenderAssignmentGroups() {
		this.genderAssignmentGroupElement?.clearItems();
		const element = SelectorEngine.findOne('select', this.genderAssignmentGroupElement?._element);
		const options = [
			`<option value="" disabled="" selected="">- Please select -</option>`,
			...Object.keys(this.genderAssignmentGroupsData).map((index) => {
				const subGroups = this.genderAssignmentGroupsData[index];
				return `<option value="${subGroups}">
							${subGroups}
						</option>`;
			})
		].join('');
		if (element) {
			element.innerHTML = options;
			this.genderAssignmentGroupElement?.generateItems();
		}
	}

	_updateSexualOrientationGroups() {
		this.sexualOrientationGroupElement?.clearItems();
		const element = SelectorEngine.findOne('select', this.sexualOrientationGroupElement?._element);
		const options = [
			`<option value="" disabled="" selected="">- Please select -</option>`,
			...Object.keys(this.sexualOrientationGroupsData).map((index) => {
				const subGroups = this.sexualOrientationGroupsData[index];
				return `<option value="${subGroups}">
							${subGroups}
						</option>`;
			})
		].join('');
		if (element) {
			element.innerHTML = options;
			this.sexualOrientationGroupElement?.generateItems();
		}
	}

	_updateGraduationYearGroups() {
		this.graduationYearGroupElement?.clearItems();
		const element = SelectorEngine.findOne('select', this.graduationYearGroupElement?._element);
		const options = [
			`<option value="" disabled="" selected="">Please select a year</option>`,
			...Object.keys(this.graduationYearGroupsData).map((index) => {
				const subGroups = this.graduationYearGroupsData[index];
				return `<option value="${subGroups}">
							${subGroups}
						</option>`;
			})
		]
		if (element) {
			element.innerHTML = options;
			this.graduationYearGroupElement?.generateItems();
		}
	}

	fieldInvalid(name) {
		const invalidField = document.getElementsByName(name)[0];
		const invalidFieldType = invalidField.getAttribute('type');
		if (name === 'university') {
			const fieldWrapper = invalidField.closest(".lta-autosuggest-input").querySelector(".lta-results-wrapper");
			fieldWrapper.classList.add(...ValidationUtils.getErrorClasses(invalidFieldType));
		} 
		if(invalidFieldType){
			const fieldWrapper = invalidField.closest(ValidationUtils.getFieldWrapper(invalidFieldType));
			fieldWrapper.classList.add(...ValidationUtils.getErrorClasses(invalidFieldType));
		} else if(invalidField.localName === 'select') {
			const fieldWrapper = invalidField.closest(ValidationUtils.getFieldWrapper('select'));
			fieldWrapper.classList.add(...ValidationUtils.getErrorClasses('select'));
		}
	}

	fieldValid(name) {
		const validField = document.getElementsByName(name)[0];
		const validFieldType = validField.getAttribute('type');
		if (name === 'university') {
			const fieldWrapper = validField.closest(".lta-autosuggest-input").querySelector(".lta-results-wrapper");
			fieldWrapper.classList.remove(...ValidationUtils.getErrorClasses(validFieldType));
		} 
		if(validFieldType){
			const fieldWrapper = validField.closest(ValidationUtils.getFieldWrapper(validFieldType));
			fieldWrapper.classList.remove(...ValidationUtils.getErrorClasses(validFieldType));
		} else if(validField.localName === 'select') {
			const fieldWrapper = validField.closest(ValidationUtils.getFieldWrapper('select'));
			fieldWrapper.classList.remove(...ValidationUtils.getErrorClasses('select'));
		}

		// remove error messages that are now valid
		const errorMessages = SelectorEngine.find(`.js-validation-${name}`, this.fieldsErrorsList);
		if (errorMessages) {
			[...errorMessages].forEach((element) => {
				element.remove();
			});
		}

		// if there are no more error messages, remove error messages container
		if (this.fieldsErrorsList.children.length === 0) {
			this.errorFieldsContainer.classList.add('u-hidden');
		}

		const formAction = this.editPersonalDetailsForm.querySelector('.js-edit-details-btn');
		if(formAction) {
			formAction.disabled = false;
		}
		if(this._cancelCta) {
			this._cancelCta.disabled = false;
		}
	}

	formInvalid() {
		this.errorFieldsContainer.classList.remove('u-hidden');
		scrollToTop();
	}

	formValidating() {
		this.fieldsErrorsList.textContent = '';
	}

	messageDisplayed(e) {
		// checks if error message isn't already added
		if (!SelectorEngine.findOne(`.js-validation-${e.field}--${e.validator}`, this.fieldsErrorsList)) {
			const listItem = document.createElement('li');
			const listSpan = document.createElement('span');
			const listLink = document.createElement('a');
			listLink.setAttribute('href', '#');
			listItem.setAttribute('class', `js-validation-${e.field} js-validation-${e.field}--${e.validator}`);
			listLink.append(document.createTextNode(e.message));
			listSpan.append(listLink);
			listItem.append(listSpan);

			this.fieldsErrorsList.append(listItem);

			listLink.addEventListener('click', (event) => {
				event.preventDefault();
				scrollToNode(e.element);
				e.element.focus();
			});
		}
	}

	async formValid() {
		this.errorFieldsContainer.classList.add('u-hidden');
		const formData = new FormData(this.editPersonalDetailsForm);
		const formAction = this.editPersonalDetailsForm.querySelector('.js-edit-details-btn');
		formAction.disabled = true;
		this._cancelCta.disabled = true;

		const dataObject = {};
		formData.forEach((value, key) => {
			dataObject[key] = value;
		});

		const newDataObject = {
			emailAddress: dataObject.emailAddress,
			firstName: dataObject.firstName,
			lastName: dataObject.lastName,
			gender: dataObject.gender,
			mobileNumber: dataObject.mobilePhone,
			marketingConsent: dataObject.marketingConsent || null,
			offerConsent: dataObject.offerConsent || null,
			termsAndConditionConsent: 'Yes',
			returnUrl: window.location.href,
			disability: {
				responseLevel1: dataObject.disability,
				responseLevel2: this.state.disabilityType
			},
			ethnicity: {
				responseLevel1: dataObject.ethnicity,
				responseLevel2: dataObject.ethnicity_subgroups || ""
			},
			sexualOrientation: dataObject.sexualOrientation,
			genderReassignment: dataObject.genderAssignment,
			faith: dataObject.faith,
			
			universityStudent: this.universityStudent,
			universityName: this.universityStudent ? this.selectedUniversity.schoolName : "",
			universityOrgId: this.universityStudent ? this.selectedUniversity.id : "",
			graduationYear: this.universityStudent ? dataObject.graduationYear : "",
		};
		const finalData = Object.assign({}, newDataObject);

		const apiResponse = await Request.post(this.editPersonalDetailsForm.dataset.url, finalData).catch(() => {
			this.errorWrapper.classList.remove('u-hidden');
			scrollToTop();
		});

		formAction.disabled = false;
		this._cancelCta.disabled = false;
		if (!apiResponse.Success) {
			const { response } = apiResponse.response;

			const responseParts = response.split(/\n/);
			const errorTitle = responseParts.shift();
			const errorMessage = this.errorDefault.querySelector('.title');
			errorMessage.innerHTML = errorTitle;

			const errorList = this.errorDefault.querySelector('ul');
			errorList.textContent = '';
			if (responseParts.length > 0) {
				responseParts.forEach((part) => {
					const liElement = document.createElement('li');
					const spanElement = document.createElement('span');
					spanElement.textContent = part;
					liElement.append(spanElement);
					errorList.append(liElement);
				});
			}
			this.errorDefault.classList.remove('u-hidden');
			this.errorDefault.scrollIntoView();
			scrollToTop();
		} else {
			this.backToUrl(undefined, formAction.dataset.target);
		}
	}

	exitEditing() {
		this._exitModal.show();
	}

	backToUrl(event, redirectUrl = undefined) {
		const rootUrl = window.location.origin
		const url = redirectUrl || event.currentTarget.dataset.target;
		window.location.href = `${rootUrl}${url}`;
	}

	universityValidation() {
		if (!this.selectedUniversity?.schoolName) {
			return { valid: false, message: 'Please search and select a university' };
		}
		return { valid: true };
	};
}

const globalEditPersonalDetails = new EditPersonalDetails();

export default globalEditPersonalDetails;